<template>
    <div class="grid">
        <div class="col-6">
            <FormField :labelName="$t('loading')" fieldName="Loading" v-model="ipbmodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect class="p-inputtext-sm" v-model="ipbmodel.Load_Port" :filter="true" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }"  :disabled="true"  />
            </FormField>
            <FormField :labelName="$t('destination')" fieldName="Destination" v-model="ipbmodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect class="p-inputtext-sm" v-model="ipbmodel.Dest_Port" :filter="true" :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{ }"  :disabled="true"  />
            </FormField>
        </div>
        <div class="col-6">
            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="ipbmodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect class="p-inputtext-sm" v-model="ipbmodel.Company_Code" :filter="true" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }"  :disabled="true"  />
            </FormField>

            <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="ipbmodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect class="p-inputtext-sm" v-model="ipbmodel.Order_Type" :filter="true" :url="this.$API_URL + 'list/order_type_code'" :minLength="0" :params="{use_ipb:true }"  :disabled="true"  />
            </FormField>

            <FormField :labelName="$t('shipment_type')" fieldName="Shipment_Type" v-model="ipbmodel" fieldClass="col-6" labelClass="col-4" >
                <CustomSelect class="p-inputtext-sm" v-model="ipbmodel.Shipment_Type" :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{group:this.$LOOKUP_GROUP.SHIPMENT_TYPE, allow_all: true}"
  :disabled="true"  />
            </FormField>
        </div>
    </div>

    <Divider />
    <div class="grid">
    <DataTable 
        v-if="ipbmodel!=null && ipbmodel.ListStoSpo!=null && ipbmodel.ListStoSpo.length>0"
        :value="ipbmodel.ListStoSpo.filter(r=>r.sto_id)"
        class="p-datatable-sm editable-cells-table col-6"
        responsiveLayout="scroll" 
        v-model:expandedRows="expandedRows"
        @rowExpand="onRowExpand"
        @rowCollapse="onRowCollapse"
        >
        <Column field="is_checked">
            <template #body="slotProps">
                <Checkbox name="is_checked" :binary="true" v-model="slotProps.data.is_checked" @input="onCheckStoSpo(slotProps.data,$ORDER_TYPE.STO)"/>
            </template>
        </Column>
        <Column field="sto_no" :header="$t('sto_no')"/>
    </DataTable>
    <DataTable 
        v-if="ipbmodel!=null && ipbmodel.ListStoSpo!=null && ipbmodel.ListStoSpo.length>0"
        :value="ipbmodel.ListStoSpo.filter(r=>r.spo_id)"
        class="p-datatable-sm editable-cells-table col-6"
        responsiveLayout="scroll" 
        v-model:expandedRows="expandedRows"
        @rowExpand="onRowExpand"
        @rowCollapse="onRowCollapse"
        >
        <Column field="is_checked">
            <template #body="slotProps">
                <Checkbox name="is_checked" :binary="true" v-model="slotProps.data.is_checked" @input="onCheckStoSpo($event,$ORDER_TYPE.SPO)"/>
            </template>
        </Column>
        <Column field="spo_no" :header="$t('spo_no')"/>
    </DataTable>
    </div>
    <Divider/>

    <DataTable 
        v-if="ipbmodel"
        :value="ipbmodel.Details"
        class="p-datatable-sm editable-cells-table"
        responsiveLayout="scroll" 
        v-model:expandedRows="expandedRows"
        @rowExpand="onRowExpand"
        @rowCollapse="onRowCollapse"
        >
        <Column :exportable="false"  :expander="true">
            <template #body="slotProps">
                <Button icon="pi pi-copy" class="p-button-primary ml-2 mr-4 p-button-sm" @click="copyDetail(slotProps)"  />
            </template>
        </Column>
        <Column field="is_checked">
            <template #header>
                <Checkbox :binary="true" v-model="this.checkAll" @input="onCheckAll($event)"/>
            </template>
            <template #body="slotProps">
                <Checkbox name="is_checked" :binary="true" v-model="slotProps.data.is_checked" @input="onCheck(slotProps.data)" :disabled="this.disableCheckDetail(slotProps.data)"/>
            </template>
        </Column>
        <Column field="Item_No" :header="$t('item_no')"> 
            <template #body="slotProps">
                {{ slotProps.index+1 }}
            </template>
        </Column>
        <Column field="Ref_No" :header="$t('ref_no')"/>
        <Column field="WB_Ref_No" :header="$t('wb_ref')"/>
        <Column field="WB_Report_Date" :header="$t('wb_report_date')">
            <template #body="slotProps">
                {{ this.$formatDate(slotProps.data.WB_Report_Date)}}
            </template>
        </Column>
        <Column field="Transporter_Code" :header="$t('transporter')"/>
        <Column field="Load_Port" :header="$t('loading')"/>
        <Column field="Dest_Port" :header="$t('destination')"/>
        <Column field="Truck_Type" :header="$t('truck_type')"/>
        <Column field="Shipment_Type" :header="$t('shipment_type')"/>
        <Column field="Freight_Cost_Suggested" :header="$t('freight_oa')"/>
        <Column field="Freight_Order" :header="$t('freight_order')"/>
        <Column field="number_of_trip" :header="$t('number_of_trip')"/>
        <Column field="Freight_Cost" :header="$t('freight_cost')">
            <template #body="slotProps">
                <InputNumber name="Freight_Cost" mode="decimal" v-model="slotProps.data.Freight_Cost" class="p-inputtext-sm w-5rem" :disabled="(slotProps.data.Freight_Approval_Status==$APPROVAL_STATUS.WAITING_FOR_APPROVAL || slotProps.data.Freight_Approval_Status==$APPROVAL_STATUS.APPROVED)" />
            </template>
        </Column>
        <Column field="Freight_Approval_Status" :header="$t('freight_approval_status')">
            <template #body="slotProps">
                {{ (slotProps.data.Freight_Approval_Status?? $APPROVAL_STATUS.NEW) }}
            </template>
        </Column>
        <template #expansion="slotProps">
            <DataTable
                v-if="ipbmodel"
                :value="slotProps.data.OrderDetails"
                class="p-datatable-sm"
                responsiveLayout="scroll"
                v-model:expandedRows="expandedRows"
                @rowExpand="onRowExpand"
                @rowCollapse="onRowCollapse"
            >
                <Column field="Order_No" :header="$t('order_no')">
                    <template #body="detail">
                        {{ detail.data.Order_No }}
                    </template>
                </Column>
                <Column field="IPB_No" :header="$t('ipb_no')">
                    <template #body="detail">
                        {{ detail.data.SAP_No }}
                    </template>
                </Column>
                <Column field="IPB_Item_No" :header="$t('ipb_item_no')">
                    <template #body="detail">
                        {{ detail.data.SAP_Item_No }}
                    </template>
                </Column>
                <Column field="material_name" :header="$t('material')">
                    <template #body="detail">
                        {{ detail.data.material_name }}
                    </template>
                </Column>
                <Column field="Qty" :header="$t('qty')">
                    <template #body="detail">
                        {{ detail.data.Qty }}
                    </template>
                </Column>
                <Column field="UOM" :header="$t('uom')">
                    <template #body="detail">
                        {{ detail.data.UOM }}
                    </template>
                </Column>
                <Column field="STO_No" :header="$t('sto_no')">
                    <template #body="detail">
                        {{ detail.data.STO_No }}
                    </template>
                </Column>
                <Column field="STO_Item_No" :header="$t('sto_item_no')">
                    <template #body="detail">
                        {{ detail.data.STO_Item_No }}
                    </template>
                </Column>
                <Column field="Without_Price" :header="$t('without_price')">
                    <template #body="detail">
                        {{ detail.data.Without_Price }}
                    </template>
                </Column>
                <Column field="SPO_No" :header="$t('spo_no')">
                    <template #body="detail">
                        {{ detail.data.SPO_No }}
                    </template>
                </Column>
                <Column field="SPO_Item_No" :header="$t('spo_item_no')">
                    <template #body="detail">
                        {{ detail.data.SPO_Item_No }}
                    </template>
                </Column>
            </DataTable>
        </template>
    </DataTable>

    <Dialog header="Confirmation" v-model:visible="showWithoutPriceConfirmation" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width:'50vw'}" :modal="true" :closable="false">
        <p>
            {{$t('message.sto_change_without_price')}}
        </p>
        <template #footer>
            <Button :label="$t('no')" icon="pi pi-times" @click="onChangeWithoutPrice(false)" class="p-button-danger"></Button>
            <Button :label="$t('yes')" icon="pi pi-check" @click="onChangeWithoutPrice(true)" class="p-button-sucess"></Button> 
        </template>
    </Dialog>
</template>

<script>
    export default{
        name: "_STO",
        emits:['close'],
        props:{
            ipbmodel: {
                type: Object,
                default: null
            },
            mode:{
                type:String,
                default:""
            },
            conditionmodel:{
                type: Object,
                default: null
            },
            defaultconditionmodel:{
                type:Object,
                default:null
            },
            defaultdetailmodel:{
                type:Object,
                default:null
            }
        },
        data(){
            return {
                checkAll:false,
                expandedRows: [],
                showWithoutPriceConfirmation: false,
            }
        },
        methods:{
            onChangePIC(event){
                if(event && this.ipbmodel){
                    this.ipbmodel.PIC_Location = event.location;
                }
            },
            onChangeCcy(event){
                if(event && this.ipbmodel){
                    if(this.ipbmodel.Conditions.length > 0){
                        for(var i=0; i< this.ipbmodel.Conditions.length;i++){
                            this.ipbmodel.Conditions[i].Ccy = event.id;
                        }
                    }

                    if(this.ipbmodel.Details.length > 0){
                        for(var i=0; i< this.ipbmodel.Details.length;i++){
                            var detail = this.stomdel.Details[i];

                            detail.Ccy = event.id;

                            if(detail.Conditions.length > 0){
                                for(var x = 0; x < detail.Conditions.length; x++){
                                    detail.Conditions[x].Ccy = event.id;
                                }
                            }
                        }
                    }
                }
            },
            onClickWithoutPrice(event){
                // if(event && this.ipbmodel){
                //     this.ipbmodel.Conditions = [];

                //     if(event == "Y"){
                //         for(var i=0; i< this.defaultconditionmodel.length;i++){
                //             var newCondition = { ...this.defaultconditionmodel[i] };
                //             this.ipbmodel.Conditions.push(newCondition);
                //         }
                //     }
                // }
                var withoutPrice = this.ipbmodel.Without_Price;
                this.ipbmodel.Without_Price = withoutPrice == "Y" ? "N" : "Y";
                this.showWithoutPriceConfirmation = true;
            },
            onChangeWithoutPrice(canContinue){
                this.showWithoutPriceConfirmation = false;

                if(canContinue){
                    var withoutPrice = this.ipbmodel.Without_Price;
                    var perValue = this.ipbmodel.Num_Trip_UOM == null || this.ipbmodel.Num_Trip_UOM == "";

                    this.ipbmodel.Without_Price = withoutPrice == "Y" ? "N" : "Y";

                    if(this.ipbmodel.Without_Price == "N"){
                        if(perValue){
                            this.ipbmodel.Conditions = [];
                            for(var i=0; i< this.defaultconditionmodel.length;i++){
                                var newCondition = { ...this.defaultconditionmodel[i] };
                                this.ipbmodel.Conditions.push(newCondition);
                            }
                        }
                        else{
                            this.ipbmodel.Details = [];
                            for(var i=0; i< this.defaultdetailmodel.length;i++){
                                var newDetail = { ...this.defaultdetailmodel[i]};
                                if(newDetail.Conditions.Length > 0){
                                    this.ipbmodel.Details[i].Conditions = [];
                                    for(var x = 0; x< newDetail.Conditions.Length;x++){
                                        var newCondition = {...newDetail.Conditions[x]};
                                        this.ipbmodel.Details[i].Conditions.push(newCondition);
                                    }
                                }


                            }
                        }
                    }


                }
            },
            addCondition() {
                var newDetail = this.conditionmodel;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };

                this.ipbmodel.Conditions.push(det);
            },
            deleteCondition(event) {
                if (event) {
                    var detail = this.ipbmodel.Conditions[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.ipbmodel.Conditions.splice(this.ipbmodel.Conditions.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            editCondition(index) {
                if (this.ipbmodel.Conditions && this.ipbmodel.Conditions.Length > 0) {
                    let m = this.ipbmodel.Conditions[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.ipbmodel.Conditions[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            onRowExpand(event){
                this.expandedRows.push(event.data);
            },
            onRowCollapse(event){
                this.expandedRows.splice(this.expandedRows.indexOf(event.data), 1);
            },
            copyDetail(event){
                if(event){
                    if(event.index != this.ipbmodel.Details.length - 1){
                        var from = this.ipbmodel.Details[event.index];
                        for(var i = (event.index + 1); i < this.ipbmodel.Details.length;i++){
                            var to = this.ipbmodel.Details[i];

                            to.Delivery_Date = from.Delivery_Date;
                            to.Plant_Supplying = from.Plant_Supplying;
                            to.Plant_Receiving = from.Plant_Receiving;
                            to.Tolerance_Over = from.Tolerance_Over;
                            to.Tolerance_Under = from.Tolerance_Under;
                            to.Tolerance_Expeditor = from.Tolerance_Expeditor;
                            to.Transaction_Type = from.Transaction_Type;
                            to.Tracking_No = from.Tracking_No;
                            to.Ref_No = from.Ref_No;
                            to.Mat_Doc_Year = from.Mat_Doc_Year;
                            to.ZGRDaily = from.ZGRDaily;
                            to.Continuous = from.Continuous;
                            to.Discharge_Port = from.Discharge_Port;
                            to.FRC_Term = from.FRC_Term;
                            to.Quantity_Term = from.Quantity_Term;
                            to.Valuation_Type = from.Valuation_Type;
                            to.Previous_STO = from.Previous_STO;
                            to.Previous_STO_Item_No = from.Previous_STO_Item_No;
                            to.IPB_No = from.IPB_No;
                            to.IPB_Item_No = from.IPB_Item_No;

                            to.Item_Text = from.Item_text;
                            to.Material_PO_Text = from.Material_PO_Text;
                            to.Delivery_Text = from.Delivery_Text;
                        }
                    }
                }
            },
            addDetailCondition(detail) {
                var newDetail = this.conditionmodel;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };

                detail.Conditions.push(det);
            },
            deleteDetailCondition(detail, index) 
            {
                let con = detail.Conditions[index];

                if (con.mode == this.$FORM_MODE_CREATE) detail.Conditions.splice(detail.Conditions.indexOf(con), 1);
                else con.mode = this.$FORM_MODE_DELETE;
            },
            editDetailCondition(data, index) {
                let m = data.mode;

                if(m == this.$FORM_MODE_UNCHANGED){
                    data.mode = this.$FORM_MODE_EDIT;
                }
                // if (this.ipbmodel.Details && this.ipbmodel.Conditions.Length > 0) {
                //     let m = this.ipbmodel.Conditions[index].mode;

                //     if (m == this.$FORM_MODE_UNCHANGED) {
                //         this.ipbmodel.Conditions[index].mode = this.$FORM_MODE_EDIT;
                //     }
                // }
            },
            simulateDeleteItem(){
                
            },
            onCheckAll(){
                var self = this;
                this.ipbmodel.Details.forEach((e,i)=>{
                    if(!this.disableCheckDetail(e)){
                        e.is_checked = self.checkAll;
                    }
                });
            },
            onCheck(data){
                const stoNo = data.OrderDetails[0].STO_No
                // if(this.ipbmodel.ListStoSpo.find(r=>r.sto_no == stoNo)!=null){
                //     this.ipbmodel.ListStoSpo.find(r=>r.sto_no == stoNo).is_checked = data.is_checked || this.ipbmodel.Details.filter(r=>r.OrderDetails.find(x=>x.STO_No == stoNo) && r.is_checked).length>0
                // }
            },
            onCheckStoSpo(data,type){
                const self = this;
                this.ipbmodel.Details.forEach((detail,i)=>{
                            console.log(detail);
                            var sameNo = detail.OrderDetails.find(r=>(r.STO_No == data.sto_no && type==self.$ORDER_TYPE.STO)||(r.SPO_No == data.spo_no && type==self.$ORDER_TYPE.SPO))
                            detail.is_checked = sameNo && data.is_checked
                            // if(sameNo){
                            //     detail.is_checked = true;
                            // }else{
                            //     detail.is_checked = false;
                            // }
                        })
            },
            disableCheckDetail(ipbDetail){
                if(this.mode == this.$FORM_MODE_DELETE && (ipbDetail.OrderDetails.find(r=>r.STO_No) || ipbDetail.OrderDetails.find(r=>r.SPO_No))){
                    return true;
                }

                if(this.mode == this.$FORM_MODE_EDIT && ipbDetail.Freight_Approval_Status!=this.$APPROVAL_STATUS.APPROVED){
                    return true;
                }

                return false;
            }
        },
        created(){

        },
        computed:{
            isCreate(){
                return this.mode == this.$FORM_MODE_CREATE;
            },
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            },
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            },
        }
    }


</script>